module.exports = __webpack_public_path__ + "img/Weapon_94.bf978b61.png";